import type { AdminApiError } from '../types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const getAdminApiError = (
  error: unknown,
  fallbackCode = 'admin_request_failed'
): AdminApiError => {
  if (isRecord(error) && isRecord(error.response)) {
    const data = error.response.data;
    if (isRecord(data) && isRecord(data.error)) {
      const code = data.error.code;
      const message = data.error.message;
      if (typeof code === 'string' && typeof message === 'string') {
        return { code, message };
      }
    }
  }
  if (error instanceof Error && error.message.trim() !== '') {
    return { code: fallbackCode, message: error.message };
  }
  return { code: fallbackCode, message: 'The admin request failed.' };
};
